// NewMark标签展示模式
export enum NewMarkDisplayMode {
  // 受NewMark标签的访问记录控制（访问过了就不展示了，访问过即用户已点击过NewMark标签关联的实体，比如菜单、tab、小红点）
  RecordControlled = 0,
  // 固定展示
  Fixed = 1,
}

// NewMark标签的类型
export enum NewMarkType {
  // New，展示为New
  New = 0,
  // Beta，展示为Beta
  Beta = 1,
}

// 缩放类型
export enum Zoom {
  // 放大
  ZoomIn = '1',
  // 缩小
  ZoomOut = '2',
}

// 接口调用场景标识，透传到请求查询参数 _at，用于后端区分同一接口在页面中的数据用途（页面 agent skill 功能）
export enum IntelligenceRequestAt {
  // 页面主数据
  Data = 'data',
  // ECharts 图表数据
  Chart = 'chart',
  // 页面辅助信息
  Info = 'info',
}
